import React, { useEffect, useState, useRef } from 'react';
import { API_BASE_URL } from '../config';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
function Admin() {
    const [menu, setMenu] = useState('interested');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showMailModal, setShowMailModal] = useState(false);
    const [mailTo, setMailTo] = useState('');
    const [mailStatus, setMailStatus] = useState('');
    const mailMsgRef = useRef();
    // smabanova api key 26c5006d-88ff-4d00-8591-56b31bb261ae
    // const OPENAI_API_KEY = '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';
    const OPENAI_API_KEY = '26c5006d-88ff-4d00-8591-56b31bb261ae';
    const getAISuggestion = async (title) => {
        try {
            const response = await fetch('https://api.sambanova.ai/v1/chat/completions', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${OPENAI_API_KEY}`,
                },
                body: JSON.stringify({
                    stream: true,
                    model: 'gpt-oss-120b',
                    messages: [
                        {
                            role: 'user',
                            content: `Generate a detailed blog post for the title: "${title}". Include an introduction, main points, and a conclusion.`
                        }
                    ]
                })
            });
            if (!response.body) throw new Error('No response body');
            const reader = response.body.getReader();
            let result = '';
            let decoder = new TextDecoder();
            while (true) {
                const { value, done } = await reader.read();
                if (done) break;
                const chunk = decoder.decode(value, { stream: true });
                chunk.split('\n').forEach(line => {
                    if (line.trim().startsWith('data:')) {
                        try {
                            const data = JSON.parse(line.replace('data: ', '').trim());
                            const delta = data.choices?.[0]?.delta;
                            if (delta && delta.role === 'assistant' && delta.content) {
                                result += delta.content;
                            }
                        } catch (e) { /* ignore parse errors for non-data lines */ }
                    }
                });
            }
            return result || 'No content generated.';
        } catch (error) {
            console.error('Error generating blog content:', error);
            return 'Error generating blog content.';
        }
    };
    const openMailModal = (email) => {
        setMailTo(email);
        setMailStatus('');
        setShowMailModal(true);
    };
    const closeMailModal = () => {
        setShowMailModal(false);
        setMailTo('');
        setMailStatus('');
        if (mailMsgRef.current) mailMsgRef.current.value = '';
    };
    const handleSendMail = async (e) => {
        e.preventDefault();
        setMailStatus('Sending...');
        const message = mailMsgRef.current.value;
        try {
            const res = await fetch(`${API_BASE_URL}/sendAdminMail.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ to: mailTo, message })
            });
            const data = await res.json();
            if (data.success) {
                setMailStatus('Mail sent successfully!');
                setTimeout(closeMailModal, 1200);
            } else {
                setMailStatus('Error: ' + (data.msg || 'Could not send mail.'));
            }
        } catch {
            setMailStatus('Error: Could not connect to server.');
        }
    };

    const [blogForm, setBlogForm] = useState({ title: '', slug: '', content: '', author: '', is_published: 1 });
    const [blogStatus, setBlogStatus] = useState('');

    const handleBlogInput = e => {
        const { name, value } = e.target;
        setBlogForm(f => ({ ...f, [name]: value }));
    };

    const handleAddBlog = async e => {
        e.preventDefault();
        setBlogStatus('Adding...');
        try {
            const res = await fetch(`${API_BASE_URL}/addBlog.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(blogForm)
            });
            const data = await res.json();
            if (data.success) {
                setBlogStatus('Blog added successfully!');
                setBlogForm({ title: '', slug: '', content: '', author: '', is_published: 1 });
            } else {
                setBlogStatus('Error: ' + (data.message || 'Could not add blog.'));
            }
        } catch {
            setBlogStatus('Error: Could not connect to server.');
        }
    };

    useEffect(() => {
        if (menu === 'interested') {
            setLoading(true);
            fetch(`${API_BASE_URL}/getInterestedData.php`)
                .then(res => res.json())
                .then(res => {
                    if (res.success) setData(res.data);
                    setLoading(false);
                });
        }
    }, [menu]);

    return (
        <div className="d-flex" style={{ minHeight: '80vh', background: '#f4f6fa' }}>
            {/* Sidebar */}
            <div className="bg-dark text-white p-4" style={{ minWidth: 220, minHeight: '100%' }}>
                <h4 className="mb-4">Control Center</h4>
                <ul className="nav flex-column nav-pills gap-2">
                    <li className="nav-item">
                        <button className={`nav-link w-100 text-start ${menu === 'interested' ? 'active' : ''}`} onClick={() => setMenu('interested')}>
                            Interested Data
                        </button>
                    </li>
                    <li className="nav-item">
                        <button className={`nav-link w-100 text-start ${menu === 'blog' ? 'active' : ''}`} onClick={() => setMenu('blog')}>
                            Add Blog
                        </button>
                    </li>
                    <li className="nav-item">
                        <button className={`nav-link w-100 text-start ${menu === 'changepw' ? 'active' : ''}`} onClick={() => setMenu('changepw')}>
                            Change Admin PW
                        </button>
                    </li>
                </ul>
            </div>

            {/* Main Content */}
            <div className="flex-grow-1 p-4">
                {menu === 'interested' && (
                    <div>
                        <h3 className="mb-4">Interested Data</h3>
                        {loading ? <div>Loading...</div> : (
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle shadow-sm bg-white">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>#</th>
                                            <th>Date</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Mobile</th>
                                            <th>Product</th>
                                            <th>Message</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.length === 0 && (
                                            <tr><td colSpan={8} className="text-center">No data found</td></tr>
                                        )}
                                        {data.map((row, idx) => (
                                            <tr key={row.intId}>
                                                <td>{idx + 1}</td>
                                                <td>{row.iDate}</td>
                                                <td>{row.contactPerson}</td>
                                                <td>{row.emailId}</td>
                                                <td>{row.mobileNumber}</td>
                                                <td>{row.productName}</td>
                                                <td style={{ maxWidth: 220, whiteSpace: 'pre-line' }}>{row.message}</td>
                                                <td>
                                                    <button type="button" className="btn btn-sm btn-outline-primary me-2" title="Send Mail" onClick={() => openMailModal(row.emailId)}>
                                                        <i className="bi bi-envelope"></i> Mail
                                                    </button>
                                                    {/* Send Mail Modal */}
                                                    {showMailModal && (
                                                        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
                                                            <div className="modal-dialog modal-dialog-centered" role="document">
                                                                <div className="modal-content" style={{ borderRadius: '1.2rem' }}>
                                                                    <div className="modal-header border-0">
                                                                        <h5 className="modal-title">Send Mail to {mailTo}</h5>
                                                                        <button type="button" className="btn-close" aria-label="Close" onClick={closeMailModal}></button>
                                                                    </div>
                                                                    <div className="modal-body">
                                                                        <form onSubmit={handleSendMail}>
                                                                            <div className="mb-3">
                                                                                <label className="form-label">Message</label>
                                                                                <textarea ref={mailMsgRef} className="form-control" rows="5" required />
                                                                            </div>
                                                                            <button type="submit" className="btn btn-primary w-100">Send Mail</button>
                                                                            {mailStatus && <div className="mt-3 alert alert-info py-2 text-center">{mailStatus}</div>}
                                                                        </form>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <a href={`https://wa.me/${row.mobileNumber}`} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-success" title="Connect WhatsApp">
                                                        <i className="bi bi-whatsapp"></i> WhatsApp
                                                    </a>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                )}
                {menu === 'blog' && (
                    <div>
                        <h3 className="mb-4">Add Blog Post</h3>
                        <form onSubmit={handleAddBlog} className="bg-white p-4 rounded shadow-sm" style={{ maxWidth: 700 }}>
                            <div className="mb-3">
                                <label className="form-label">Title</label>
                                <input type="text" className="form-control" name="title" value={blogForm.title} onChange={handleBlogInput} required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Slug (URL)</label>
                                <input type="text" className="form-control" name="slug" value={blogForm.slug} onChange={handleBlogInput} required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Author</label>
                                <input type="text" className="form-control" name="author" value={blogForm.author} onChange={handleBlogInput} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Content</label>
                                <textarea className="form-control" name="content" value={blogForm.content} onChange={handleBlogInput} rows={8} required />
                            </div>
                            {/* Live Markdown Preview */}
                            <div className="mb-3">
                                <label className="form-label">Preview</label>
                                <div className="border rounded p-3 mb-3 bg-light" style={{ maxHeight: 150, overflowY: 'auto' }}>
                                    <ReactMarkdown>{blogForm.content}</ReactMarkdown>
                                </div>
                            </div>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={async () => {
                                    setBlogStatus('Generating suggestion...');
                                    const suggestion = await getAISuggestion(blogForm.title);
                                    setBlogForm(f => ({ ...f, content: suggestion }));
                                    setBlogStatus('Suggestion added!');
                                }}
                            >
                                Suggest Content
                            </button>
                            
                            <div className="mb-3 form-check">
                                <input type="checkbox" className="form-check-input" id="is_published" name="is_published" checked={!!blogForm.is_published} onChange={e => setBlogForm(f => ({ ...f, is_published: e.target.checked ? 1 : 0 }))} />
                                <label className="form-check-label" htmlFor="is_published">Publish</label>
                            </div>
                            <button type="submit" className="btn btn-primary">Add Blog</button>
                            {blogStatus && <div className="mt-3 alert alert-info py-2 text-center">{blogStatus}</div>}
                        </form>
                    </div>
                )}
                {menu === 'changepw' && (
                    <div>
                        <h3>Change Admin Password</h3>
                        <div className="alert alert-info">Password change form coming soon...</div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Admin;
